import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from 'shared/button';
import Form from './form';
import Modal from 'components/modal';
import { getParentOptionValue } from 'bundles/crm/parent_helpers';
import { saveActivity } from './form/helpers';

export default function ActivityModal({
  activity: initialActivity,
  header,
  options,
  show,
  tagText,
  onHide,
  onSave,
}) {
  const [activity, setActivity] = useState({ ...initialActivity });
  const [errors, setErrors] = useState([]);
  const [saving, setSaving] = useState(false);

  function reset() {
    const formActivity = { ...initialActivity };
    if (initialActivity.id) {
      formActivity.parentOptionValue = getParentOptionValue(initialActivity);
    } else if (options?.parents?.length) {
      formActivity.parentOptionValue = options.parents[0].value;
    }

    setActivity(formActivity);
    setErrors([]);
    setSaving(false);
  }

  function close() {
    // Tagify's uncontrolled nature is weird - if we don't clear the body, if it is modified and
    // then the modal is closed without saving, the next time it opens, tagifiy will re-initialize
    // state with the old value
    setActivity({});
    onHide();
  }

  async function save() {
    setErrors([]);
    setSaving(true);

    try {
      onSave(await saveActivity(activity));
      close();
    } catch (error) {
      setErrors(error);
    }

    setSaving(false);
  }

  return (
    <Modal centered show={show} size="lg" onHide={close} onShow={reset}>
      <Modal.Header closeButton>
        {header}
      </Modal.Header>

      <Modal.Body>
        <Form
          activity={activity}
          errors={errors}
          options={options}
          tagText={tagText}
          onChange={setActivity}
        />
      </Modal.Body>

      <Modal.Footer>
        <Button.Cancel disabled={saving} onClick={close} />
        <Button.Primary disabled={saving || !activity.body?.trim()} onClick={save}>
          Save Activity
        </Button.Primary>
      </Modal.Footer>
    </Modal>
  );
}

ActivityModal.propTypes = {
  activity: PropTypes.object,
  header: PropTypes.string.isRequired,
  options: PropTypes.object,
  show: PropTypes.bool,
  tagText: PropTypes.string,
  onHide: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};
